import { createAction } from '@reduxjs/toolkit';
import { USER_TIMED_OUT } from 'constants/paths';
import { showHideLoader } from './loader';
import { navigateToScreen } from './navigation';
import { setHasUserTimedOut } from './userSession';

export const deleteTokenRequest = createAction('token/delete', function prepare(token) {
  return {
    payload: {
      endPoint: `/banks/:bankId/auth/provider/oauth2/token/${token}`,
      method: 'delete',
      isPaasApi: true,
      addHeader: true,
      success: (response) => (dispatch) => {
        dispatch(deleteTokenSuccess(response));
        dispatch(showHideLoader(false));
      },
      failure: (response) => (dispatch) => {
        dispatch(deleteTokenFailed(response));
        dispatch(showHideLoader(false));
      },
      version: '1.2.0'
    }
  };
});

export const deleteToken = (timerRef) => (dispatch, getState) => {
  const {
    config: { accessToken }
  } = getState();
  dispatch(setHasUserTimedOut());
  if (accessToken) {
    dispatch(deleteTokenRequest(accessToken));
  } else {
    dispatch(navigateToScreen(USER_TIMED_OUT));
    timerRef.current.reset();
  }
};

export const deleteTokenSuccess = createAction('token/deleteSuccess', function prepare(response) {
  return {
    payload: response
  };
});

export const deleteTokenFailed = createAction('token/deleteSuccess', function prepare(response) {
  return {
    payload: response
  };
});
